export default "__VITE_ASSET__muUqYor8__"